import addClassName from './addClassName';
import {tearTheBagIconAdd} from './tearTheBagIconAdd';

export default function (e, articleArea, articleWrapper) {
	articleArea.innerHTML = '';
	const siteurl = document.getElementById('js-page-wrapper').getAttribute('data-siteurl');
	const myid = e.target.getAttribute('data-id');

	if(myid) {
		articleWrapper.classList.add('is-show');
		trigger(window, 'loadingStart');
		const parent = e.target.parentNode;
		const el = e.target;
		axios({
			method: 'get',
			url: siteurl + '/articleapi/',
			responseType:'document',
			params: {
				myid: myid
			},
		})
			.then(function (response) {
				const article = response.data.getElementById('js-article');
				const anchors = article.querySelectorAll('a');
				addClassName(anchors);
				articleArea.append(article);
				setTimeout(function() {
					article.classList.add('is-ready');
					tearTheBagIconAdd();
				});
				articleArea.scrollTo(0,0);
				trigger(window, 'loadingEnd');
				trigger(window, 'articleLoaded');
			})
			.catch(function (error) {
				console.log(error);
				trigger(window, 'loadingEnd');
			})
			.then(function () {
			}
		);
	}
}
